import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'

import { RenderSettingsCards } from './layout/RenderSettingsCards'

export const GeneralSettings = () => {
    const [searchTerm, setSeachTerm] = useState<string>('')
    const { t } = useTranslation()

    return (
        <WithHeaderSection
            customClass='settings-whs'
            headerSection={
                <LayoutHeader
                    type='search-with-title'
                    title={t('general')}
                    searchValue={searchTerm}
                    searchFn={(term: string) => {
                        setSeachTerm(term)
                    }}
                    clearFn={() => {
                        setSeachTerm('')
                    }}
                    additionalProps={{ placeholder: t('searchSettings') }}
                />
            }
        >
            <RenderSettingsCards type='general' searchTerm={searchTerm} />
            {/* <div style={{ width: '100%', height: 0, paddingBottom: '7rem' }} className='padding-placeholder'/> */}
        </WithHeaderSection>
    )
}
